var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { space, position, flex, flexDirection, themeGet, top, color, borderRadius, width, maxWidth, zIndex, backgroundColor, } from 'styled-system';
import css from '@emotion/css';
import { boxSizing } from '../../../common/theme/system-utilities';
import { Text, SmallText } from '../../../common/components/Text';
import { Link } from '../../../common/components/Link';
import { getTrackerProps } from '../../../common/tracking/getTrackerProps';
import { Img } from './Img';
export var SuggestionsList = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style: none;\n  -webkit-appearance: none;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n\n  ", ";\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n"], ["\n  list-style: none;\n  -webkit-appearance: none;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n\n  ", ";\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ",
    "\n"])), position, flex, flexDirection, space, top, borderRadius, width, maxWidth, backgroundColor, boxSizing, zIndex, function (_a) {
    var isOpen = _a.isOpen, timeout = _a.timeout, theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: ", ";\n      opacity: ", ";\n      box-shadow: ", ";\n      padding-bottom: ", ";\n      transition-property: opacity, box-shadow;\n      transition-timing-function: ", ";\n      transition: ", "ms;\n      border-radius: ", ";\n    "], ["\n      display: ", ";\n      opacity: ", ";\n      box-shadow: ",
        ";\n      padding-bottom: ", ";\n      transition-property: opacity, box-shadow;\n      transition-timing-function: ", ";\n      transition: ", "ms;\n      border-radius: ", ";\n    "])), isOpen ? 'flex' : 'inline', isOpen ? '1' : '0', isOpen
        ? '0 2px 6px 0 rgba(44, 54, 56, 0.3)'
        : '0 0 0 0 rgba(44, 54, 56, 0.3)', isOpen ? theme.space[1] + "px" : '0', isOpen ? 'ease-out' : 'ease-in', timeout, !theme.isHome24 && '0 !important');
});
SuggestionsList.defaultProps = {
    flex: '1',
    flexDirection: 'column',
    position: [null, 'absolute'],
    width: 1,
    top: [null, '100%'],
    px: 0,
    pt: 0,
    m: 0,
    borderRadius: [null, '3px'],
    boxSizing: 'border-box',
    zIndex: [null, 9999],
    backgroundColor: 'white',
};
var SuggestionsListItemContainer = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", ";\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ", ";\n  }\n"], ["\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", ";\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ", ";\n  }\n"])), color, themeGet('colors.gray.4'));
var SuggestionsListItemLink = styled.a(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n\n  ", ";\n"])), space);
SuggestionsListItemLink.defaultProps = {
    as: Link,
    p: 2,
};
var SuggestionsListItemName = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  ", ";\n"], ["\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  ", ";\n"])), space);
SuggestionsListItemName.defaultProps = {
    as: Text,
    fontSize: [3, 4],
    ml: 2,
};
export var createHighlightedText = function (text, match) {
    // Trim the string and escape special regex chars
    match = match.trim().replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    var regex = new RegExp("(" + match + ")", 'ig');
    return match ? text.replace(regex, '<strong>$1</strong>') : text;
};
var SuggestionsListItemCount = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex: none;\n  white-space: nowrap;\n  ", ";\n"], ["\n  flex: none;\n  white-space: nowrap;\n  ", ";\n"])), space);
SuggestionsListItemCount.defaultProps = {
    as: SmallText,
    ml: 2,
};
export function SuggestionsListItem(_a) {
    var suggestionItem = _a.suggestionItem, highlighted = _a.highlighted, inputValue = _a.inputValue, mobile = _a.mobile, listIndex = _a.listIndex, listItems = _a.listItems, props = __rest(_a, ["suggestionItem", "highlighted", "inputValue", "mobile", "listIndex", "listItems"]);
    // eslint-disable-next-line camelcase, no-underscore-dangle, id-blacklist, id-match
    var __html = useMemo(function () { return createHighlightedText(suggestionItem.name, inputValue); }, [suggestionItem.name, inputValue]);
    return (React.createElement(SuggestionsListItemContainer, __assign({ "data-testid": "suggestion-list-item", bg: highlighted ? 'gray.2' : 'gray.0' }, props),
        React.createElement(SuggestionsListItemLink, __assign({}, getTrackerProps({
            href: suggestionItem.urlEncoded,
            'data-testid': 'suggestion-list-item-link',
            onClick: function (event) {
                // We want to preserve link behaviour
                // and not delegate it to Downshift,
                // that way people can click on a link
                // to open in new tabs, etc
                event.stopPropagation();
            },
        }, {
            event: 'internal search',
            eventData: {
                placement: 'search',
                searchTerm: inputValue,
                label: suggestionItem.name,
                listIndex: listIndex,
                listItems: listItems,
                listLength: listItems.length,
            },
        })),
            React.createElement(Img, { src: suggestionItem.image, alt: suggestionItem.name, "data-testid": "suggestion-list-item-image" }),
            React.createElement(SuggestionsListItemName, { dangerouslySetInnerHTML: { __html: __html }, "data-testid": "suggestion-list-item-name" }),
            suggestionItem.count && (React.createElement(SuggestionsListItemCount, { "data-testid": "suggestion-list-item-count" }, mobile ? suggestionItem.count : suggestionItem.productCount)))));
}
export default SuggestionsListItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
